<template>
  <page-loader v-if="loadStatus == 'loading'" />
  <div v-else class="contain-section">
    <div class="row">
      <div class="full-map-section">
        <Map
          v-if="hasMounted"
          :map-data="vikingResult.poulationGroupCmsInformation.geoJson"
        />

        <!-- <div class="map-detail">
          <h3 class="col-sm-12 align-items-center text-center justify-content-center d-flex">{{ vikingResult.poulationGroupCmsInformation.heading }}</h3>
          <div class="col-sm-12 align-items-center justify-content-center d-flex">
            <div class="percentage-area">
              <div class="progress-wrapper"><svg class="progress-circle" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="40"></circle>
                </svg><svg class="progress-bar" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="40"></circle>
                </svg><text class="progress-text" x="50" y="50"><b>{{ vikingResult.percentile }}</b><span>(Viking Index)</span></text></div>
            </div>
          </div>
        </div> -->
      </div>

      <div class="col-sm-12">
        <div class="map-detail-section">
          <div class="map-advt">
            <img :src="vikingResult.poulationGroupCmsInformation.mainImage.urlRaw" />
          </div>
          <div class="location-detail new-location-details">
            <h4>{{ vikingResult.poulationGroupCmsInformation.heading }}</h4>
            <div v-html="vikingResult.poulationGroupCmsInformation.text"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../../styles/pages/map.scss";
import { ref, onMounted } from "vue";
import Map from "@/view/vikings/VikingGeoJsonMap.vue";
export default {
  name: "VikingMapSection",
  props: { vikingResult: Object },
  components: { Map },
  setup() {
    const hasMounted = ref(false);
    const loadStatus = ref("loading");
    const mapData = ref({});
    onMounted(async () => {
      loadStatus.value = "loaded";
      hasMounted.value = true;
    });
    return { mapData, hasMounted };
  },
};
</script>
